import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import configureAuthStore from './store/authStore';
import configureNavStore from './store/navStore';
import configureGraphStore from './store/graphStore';
import configureLangStore from './store/langStore';
import { BrowserRouter } from 'react-router-dom';
import { MuiThemeProvider } from '@material-ui/core';
import { theme } from './utils/theme';

configureAuthStore();
configureNavStore();
configureGraphStore();
configureLangStore();

ReactDOM.render(
  <BrowserRouter>
    <React.StrictMode>
      <MuiThemeProvider theme={theme}>
          <App />
      </MuiThemeProvider>
    </React.StrictMode>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
